/**
 * Created by ronmarsiano on 09/07/2018.
 */


mainApp.component('ikeV2TestConnectionFlags', {
    templateUrl: '/public/components/ikeV2TestConnectionFlags.html',
    bindings: {
        flags: '='
    },
    controller:ikeV2TestConnectionFlagsCtrl
});



function ikeV2TestConnectionFlagsCtrl($scope) {

    var ctrl = this;

    /**
     * should return true only for this state :
     * { “sa_initiated_by_us”: true, “established”: true, “usable”: true, “pending_close_timeout”: false,
     * “pending_remove_timeout”: false }
     * @returns {*|boolean}
     */
    ctrl.$onInit = function() {
        ctrl.isFlagsCorrect = ctrl.isTrue(ctrl.flags.sa_initiated_by_us) &&
            ctrl.isTrue(ctrl.flags.established) && ctrl.isTrue(ctrl.flags.usable) &&
            !ctrl.isTrue(ctrl.flags.pending_close_timeout) && !ctrl.isTrue(ctrl.flags.pending_remove_timeout) ;
        return ctrl.isFlagsCorrect;
    };

    $scope.$watch('disabled', function(newValue, oldValue) {
        console.log('disabled');
    }, true);

    /**
     * returns true if the given string is "true"
     * @param str
     * @returns {boolean}
     */
    ctrl.isTrue = function(str) {
        return str && str=='true' || str == true;
    }

};

